import {HTTP} from '@/common/utils/http';
import {QueryParams} from '@/common/utils/query-params';
import {PaginationParams} from '@/common/utils/pagination-params';

export const ChildrenService = {
    getChildrenBySchool(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`schools/${schoolId}/children`);
        return HTTP.get(url);
    },

    getChildrenList(schoolId) {
        return HTTP.get(`/reports/school/${schoolId}/children`);
    },

    sendEmailToParents(schoolId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/children/email`, formData, { headers });
    },

    sendEmailToAllParents(schoolId, body, attachment, contactTypes) {  
        const headers = { 
            'Content-type': 'multipart/form-data'
        };

        const payload = {
            subject: body.subject,
            message: body.message, 
            entityIds: contactTypes.includes('primary'),
            secondaryEntityIds: contactTypes.includes('secondary')
        };

        const formData = new FormData();
        const json = JSON.stringify(payload);
        formData.append("emailAllForm", json);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/children/email-all`, formData, { headers });
    },

    sendSMSToParents(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/children/sms`, form);
    },

    getAllSchoolChildren(schoolId) {
        return HTTP.get(`/schools/${schoolId}/children/all`);
    },

    getChildrenForEnrollment(schoolId) {
        return HTTP.get(`/schools/${schoolId}/children/for-enrollment`);
    },

    getXlsFileFieldNames(schoolId) {
        return HTTP.get(`/schools/${schoolId}/children/xls-fields`);
    },

    getContactsXls(schoolId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/children/xls`);
        return HTTP.get(url);
    },

    deleteContact(schoolId, childId) {
        return HTTP.delete(`/schools/${schoolId}/children/${childId}`);
    },

    deleteContacts(schoolId, childIds) {
        return HTTP.delete(`/schools/${schoolId}/children?childIds=${childIds}`);
    },

    getChildGeneralInfoById(childId) {
        return HTTP.get(`/children/${childId}`);
    },

    getChildRosterInfoById(childId, params) {
        const url = QueryParams
            .createParams(params)
            .applyToUrl(`/children/${childId}/roster/details`);
        return HTTP.get(url);
    },

    getChildScheduleInfoById(schoolId, childId) {
        return HTTP.get(`/schools/${schoolId}/children/${childId}/schedule/details`);
    },

    getChildPickUpList(schoolId, childId) {
        return HTTP.get(`/schools/${schoolId}/children/${childId}/check-out-persons`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/children.service.js